import { render } from "./DepartmentDetails.vue?vue&type=template&id=57f274c4&scoped=true&ts=true"
import script from "./DepartmentDetails.vue?vue&type=script&lang=ts"
export * from "./DepartmentDetails.vue?vue&type=script&lang=ts"

import "./DepartmentDetails.vue?vue&type=style&index=0&id=57f274c4&scoped=true&lang=css"
import "./DepartmentDetails.vue?vue&type=style&index=1&id=57f274c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f274c4"]])

export default __exports__